<template>
    <fup-content-block :container="true" :full-size="false">
        <div class="mt-4 mb-4 text-center">
            <p class="lead text-muted"><i class="far fa-hourglass-half"></i></p>
            <div class="small text-muted">Произошла ошибка, повторите позже.</div>
        </div>
    </fup-content-block>
</template>

<script>
    export default {
        name: "LoadingComponent"
    }
</script>